export const baseURL = {
  dev: 'http://localhost:8000/',
  prod: 'https://pwpbcovid.herokuapp.com/',
}
